import { RefObject, useEffect } from 'react';

export const useOutsideClickDetector = (
  node: RefObject<HTMLElement>,
  onOutsideClick: () => void,
  secondNode?: RefObject<HTMLElement>,
  thirdNode?: RefObject<HTMLElement>,
  fourthNode?: RefObject<HTMLElement>
) => {
  useEffect(() => {
    const handleMouseDown: EventListener = (event) => {
      const root = document.getElementById('root');
      const target = event.target as HTMLElement;

      if (
        node?.current?.contains(target) ||
        secondNode?.current?.contains(target) ||
        thirdNode?.current?.contains(target) ||
        fourthNode?.current?.contains(target) ||
        !root?.contains(target)
      ) {
        // inside click
        return;
      }
      // outside click
      if (onOutsideClick) onOutsideClick();
    };
    document.addEventListener('mousedown', handleMouseDown);
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [node, secondNode, thirdNode, fourthNode, onOutsideClick]);
};
